import type { Handleiding } from './soort';

export const es: Handleiding = {
  code: 'es',
  titel: 'Manual',
  inleiding:
    'Ask Gio Tolk traduce una conversación entre dos personas que no hablan el mismo idioma. Aquí abajo está lo que hace cada botón.',
  knop: 'Abrir el manual',
  sluiten: 'Cerrar',
  groepGebruik: 'Participar',
  groepBeheer: 'Configurar y gestionar',
  delen: [
    {
      titel: 'Hablar',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Habla',
          uitleg:
            'Toca una vez para empezar. La grabación se detiene sola en cuanto callas durante algo más de un segundo, o si tocas otra vez. Al cabo de un minuto se detiene igualmente.',
        },
        {
          kop: 'Un solo sonido a la vez',
          uitleg:
            'Mientras la app habla, no puedes grabar. Y mientras grabas, una traducción que llega espera a que termines. Si no, tu micrófono graba la app y cree que lo dijiste tú.',
        },
        {
          kop: 'Escribe aquí tu mensaje',
          uitleg:
            'Funciona junto al habla y pasa por la misma traducción. Enter envía, mayúsculas con enter hace una línea nueva.',
        },
        {
          kop: 'Tiempo para corregir',
          uitleg:
            'Aquí pones cuántos segundos tienes para releer tu frase transcrita antes de que salga. En cero sale enseguida.',
        },
        {
          kop: 'Revisar y enviar siempre tú mismo',
          uitleg:
            'Sin reloj. Cada frase espera a que pulses enviar. Para quien quiere revisar cada frase.',
        },
        {
          kop: 'Reproducir la traducción enseguida',
          uitleg:
            'Está activado. Desactívalo si prefieres leer primero y decidir tú cuándo escuchas.',
        },
      ],
    },
    {
      titel: 'Leer los mensajes',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Lo que está en grande',
          uitleg:
            'Lo que está en TU idioma está en grande. En tu propia frase eso es tu texto original, para que puedas comprobar si la app te entendió bien. En una frase del otro es la traducción.',
        },
        {
          kop: 'Desplegar el original o la traducción',
          uitleg: 'El otro idioma está debajo, plegado. Toca la línea para abrirlo.',
        },
        {
          kop: 'El triangulito',
          uitleg: 'Vuelve a reproducir la traducción.',
        },
        {
          kop: 'La cabeza que habla',
          uitleg:
            'Reproduce la grabación propia del otro. Solo aparece en un mensaje HABLADO y solo si «envía también tu propia voz» está activado. Un mensaje escrito no tiene grabación.',
        },
      ],
    },
    {
      titel: 'Botones en la parte de arriba',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Menos y más',
          uitleg: 'Hace el texto más pequeño o más grande. En cinco pasos, y se queda guardado.',
        },
        {
          kop: 'El micrófono',
          uitleg: 'Oculta el botón de hablar si solo escribes. Así ganas espacio.',
        },
        {
          kop: 'El teclado',
          uitleg:
            'Oculta el campo de texto. Siempre queda uno de los dos activo, si no ya no podrías decir nada.',
        },
      ],
    },
    {
      titel: 'Entrar',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Qué idioma hablas',
          uitleg:
            'Esta elección determina también el idioma de los botones y los avisos. Así que cada uno ve una pantalla distinta, y esa es la idea.',
        },
        {
          kop: 'Tu voz en la traducción',
          uitleg:
            'Elige si suenas como hombre o como mujer. Esto es TUYO, no de la sala: cada participante elige por separado.',
        },
        {
          kop: 'Permiso para el micrófono',
          uitleg:
            'El navegador lo pide al entrar. Si dices que no, todavía puedes escribir. Dar permiso se puede después a través del candado en la barra de direcciones.',
        },
      ],
    },
    {
      titel: 'Abajo, plegado',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Lista de palabras de reserva',
          uitleg:
            'Palabras que siempre deben traducirse igual: nombres, términos técnicos, marcas. Vale para toda la sala.',
        },
        {
          kop: 'Cambiar los ajustes',
          uitleg:
            'El idioma, la voz, el tono y la corrección ortográfica también se pueden cambiar EN MEDIO de la conversación. Lo que cambies aquí vale enseguida para los dos.',
        },
      ],
    },
    {
      titel: 'Empezar una conversación',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Nombre de la conversación',
          uitleg:
            'Puede quedar vacío. Solo aparece arriba en tu pantalla, para que sepas con quién hablas.',
        },
        {
          kop: 'Hablante 1 y hablante 2',
          uitleg:
            'Los dos idiomas de esta conversación. Quien entra primero ocupa el primer sitio. Todavía puedes cambiar los idiomas después.',
        },
        {
          kop: 'Tono de la traducción',
          uitleg:
            'A la izquierda eliges tuteo o trato de usted, a la derecha el ambiente: neutro, amistoso, profesional, oficial o de pareja. Sin indicación el modelo elige casi siempre la forma formal, y en una conversación normal eso suena distante.',
        },
        {
          kop: 'Envía también tu propia voz',
          uitleg:
            'El otro puede oír tu propia grabación además de la traducción. Práctico para aprender un idioma. Desactívalo en una conversación delicada: quien recibe la grabación puede guardarla.',
        },
        {
          kop: 'Corrige las faltas en tu propio texto',
          uitleg:
            'Está activado. Desactívalo para ver qué entendió realmente el modelo. Si sale una frase rara, sabes si la entendió mal o la entendió bien y luego la alisó.',
        },
        {
          kop: 'Con código PIN',
          uitleg:
            'Pasa el código de viva voz, no en el mismo mensaje que el enlace. Eso protege contra un enlace reenviado.',
        },
        {
          kop: 'El código QR',
          uitleg:
            'Haz que el otro lo escanee, o envía el enlace. Una sala caduca sola al cabo de cuatro horas.',
        },
      ],
    },
    {
      titel: 'Qué pasa con tu conversación',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'El texto no se guarda',
          uitleg:
            'Lo que decís no entra en la base de datos. Solo cuándo y cuánto se habló, para los costes.',
        },
        {
          kop: 'Las grabaciones desaparecen solas',
          uitleg: 'El audio se queda diez minutos en la memoria y luego se va.',
        },
        {
          kop: 'La sala caduca',
          uitleg: 'Cuatro horas después de crearla. Después el enlace ya no funciona.',
        },
        {
          kop: 'Hay un presupuesto',
          uitleg:
            'Por sala y por mes. Si se llena, la app deja de traducir y lo dice. Eso no es una avería.',
        },
      ],
    },
  ],
};
